import React, { Fragment } from "react";
import { Col, Accordion } from "react-bootstrap";

import imgReciclar from "../../assets/imgReciclar.png";

const RazonNueve = () => {
  return (
    <Fragment>
      <Col
        lg={6}
        className="contentCards cardLigth "
        id="razonNueve"
        data-aos="fade-left"
        data-aos-offset="300"
        data-aos-duration="1000"
        data-aos-easing="ease-out"
      >
        <div className="contentCardsInferiores">
          <h4>Razón #9</h4>
          <h2
            data-aos="fade-left"
            data-aos-offset="300"
            data-aos-duration="500"
          >
            Desarrollo sostenible
          </h2>
          <p data-aos="fade-left" data-aos-offset="300" data-aos-duration="500">
            Piscinas diseñadas bajo un concepto ecológico, con mayor ahorro y
            fomentando el cuidado eficiente del agua.
          </p>
          <Accordion>
            <Accordion.Item eventKey="0">
              <Accordion.Header>Ver más</Accordion.Header>
              <Accordion.Body>
                <p className="textoCalidad">
                  {" "}
                  Con un fuerte compromiso social, IPC Pools contribuye al
                  cuidado del planeta con una política empresarial sustentable y
                  trabajando en la reducción de residuos en el proceso
                  industrial. También promueve la vida activa y la alimentación
                  saludable como política de recursos humanos. Lleva adelante
                  alianzas institucionales para crear valor en temas de salud,
                  prevención, atención y cuidados a los más necesitados en la
                  provincia de Mendoza, a través de FUNDAVITA. Y comparte
                  valores humanos sobre el tiempo para el disfrute en familia,
                  con los amigos, de entretenimiento y actividades deportivas
                  con clubes en todo el país.
                </p>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </div>

        <img
          src={imgReciclar}
          className="w-100"
          alt="Desarrollo Sostenible"
          data-aos="fade-up"
          data-aos-offset="300"
          data-aos-duration="500"
        ></img>
      </Col>
    </Fragment>
  );
};

export default RazonNueve;
